import React, { useEffect, useState, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Form,
  Button,
  Card,
  Col,
  Container,
  Row,
  Table,
} from "react-bootstrap";
import Nav from "./Navbar";
import Footer from "./Footer";
import linking1 from "../Images/linking1.png";
import linking2 from "../Images/linking2.svg";
import Domainpage from "./Dapa";
import SideTab from "./Toolstab";
import TestimonialPage from "./Testonomialraghar";
import { useNavigate } from "react-router-dom";
import key1 from "../Images/key1.svg";
import key2 from "../Images/key2.svg";
import key3 from "../Images/key3.svg";
import key4 from "../Images/key4.svg";
import key5 from "../Images/key5.svg";
import key6 from "../Images/cardimg5.svg";
import core1 from "../Images/core1.png";
import core2 from "../Images/core2.png";
import core3 from "../Images/core3.png";
import core4 from "../Images/core4.png";
import core5 from "../Images/core5.png";
import core6 from "../Images/core6.png";
import pay from "../Images/pay.png";
import Linkingdomainchecker from "./Linkingdomainchecker";
import { BASE_URL_API_TRANXT_UAT_API } from "../Utils/Constant";
import {
  FaArrowRight,
  FaChartBar,
  FaChevronLeft,
  FaChevronRight,
  FaFileAlt,
  FaSearch,
} from "react-icons/fa";
import { basicauth } from "../Utils/Credentials";
import { Helmet } from "react-helmet";
const Linkingdomain = () => {
  const jsonLdData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Linking Domain Checker – Boost Website Authority with SeoBix",
    url: "https://seobix.com/linking-domain-checker",
    description:
      "Improve rankings with powerful linking domains. Build authority fast — start optimizing today!",
    publisher: {
      "@type": "Organization",
      name: "Seobix",
      url: "https://seobix.com",
      logo: {
        "@type": "ImageObject",
        url: "https://seobix.com/Images/Backlinks.png",
      },
    },
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Linking Domain Checker",
          item: "https://seobix.com/linking-domain-checker",
        },
      ],
    },
    mainEntity: {
      "@type": "SoftwareApplication",
      name: "Linking Domain Checker",
      applicationCategory: "SEO Tool",
      operatingSystem: "Web",
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD",
        category: "Free SEO Tool",
      },
    },
    inLanguage: "en",
    keywords: [
      ".link domain",
      "link to domain",
      "link domain",
      "link domains",
      "linking domains",
      "linking domain",
      "domain link checker",
      "linking domains checker",
      "domain links",
      "linking root domains",
    ],
    mainEntityOfPage: [
      {
        "@type": "Question",
        name: "What is a Linking Domain Checker?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "A Linking Domain Checker analyzes all domains that link to your website, helping improve website authority and monitor backlink quality.",
        },
      },
      {
        "@type": "Question",
        name: "Why should I check linking domains?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Checking linking domains ensures your website has quality backlinks, avoids toxic links, and boosts search engine rankings.",
        },
      },
      {
        "@type": "Question",
        name: "Can I use this tool to monitor multiple domains?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, the SeoBix Linking Domain Checker allows you to monitor multiple domains efficiently and track linking domains to improve SEO performance.",
        },
      },
    ],
  };

  return (
    <Container fluid className="p-0" style={{ overflowX: "clip" }}>
      <div>
        <Helmet>
          <title>
            Linking Domain Checker – Boost Website Authority with SeoBix
          </title>
          <meta
            name="description"
            content="Improve rankings with powerful linking domains. Build authority fast — start optimizing today!"
          />
          <meta
            name="keywords"
            content=".link domain, link to domain, link domain, link domains, linking domains, linking domain, domain link checker, linking domains checker, domain links, linking root domains"
          />
          <link
            rel="canonical"
            href="https://seobix.com/linking-domain-checker"
          />

          <meta
            property="og:title"
            content="Linking Domain Checker – Boost Website Authority with SeoBix"
          />
          <meta
            property="og:description"
            content="Improve rankings with powerful linking domains. Build authority fast — start optimizing today!"
          />
          <meta
            property="og:url"
            content="https://seobix.com/linking-domain-checker"
          />
          <meta property="og:site_name" content="Seobix" />
          <meta property="og:type" content="website" />
          <meta
            property="og:image"
            content="https://seobix.com/Images/Backlinks.png"
          />
          <meta property="og:image:width" content="600" />
          <meta property="og:image:height" content="600" />
          <meta property="og:locale" content="en_US" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:title"
            content="Linking Domain Checker – Boost Website Authority with SeoBix"
          />
          <meta
            name="twitter:description"
            content="Improve rankings with powerful linking domains. Build authority fast — start optimizing today!"
          />
          <meta
            name="twitter:image"
            content="https://seobix.com/Images/Backlinks.png"
          />
          <meta name="twitter:site" content="@seobix" />
          <meta name="twitter:creator" content="@seobix" />

          <script type="application/ld+json">
            {JSON.stringify(jsonLdData)}
          </script>
        </Helmet>
        <Nav />
      </div>

      <Row className="d-flex justify-content-center mt-4">
        <Col className="col-md-10 col-12 mb-4">
          <div className="mx-2">
            <h1 className="text-center mb-4">
              Linking Domain – Analyze Referring Domains for Smarter SEO
            </h1>
            <div
              className=" mt-md-5 p-4 "
              style={{
                background:
                  "linear-gradient(to right, #AFDDFF 0%, #C5E7FF 30%, #DAF0FF 60%, #EDF8FF 85%, #FFFFFF 100%)",
              }}
            >
              <Linkingdomainchecker />
            </div>
          </div>
        </Col>
      </Row>
      <Row className="justify-content-center" style={{ margin: "0" }}>
        <Col md={10}>
          <Row className="justify-content-between">
            <Col md={8}>
              <Content />
            </Col>

            <Col md={3}>
              <div
                className="mb-5"
                style={{
                  position: "sticky",
                  top: "20px",
                  zIndex: 10,
                  background: "#f8f9fa",
                  padding: "1rem",
                  borderRadius: "10px",
                }}
              >
                <h5
                  className="text-center mb-4"
                  style={{
                    fontWeight: "bold",
                    fontSize: "1.3rem",
                    color: "#fff",
                    backgroundColor: "#799EFF",
                    display: "inline-block",
                    padding: "6px 16px",
                    borderRadius: "0.5rem",
                  }}
                >
                  🚀 Explore More SEO Tools
                </h5>
                <SideTab />
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <div
        className="m-0 p-0"
        style={{
          overflow: "hidden",
          background:
            "linear-gradient(to right, rgb(175, 221, 255), rgb(255, 255, 255))",

          borderTopRightRadius: "2rem",
          borderTopLeftRadius: "2rem",
        }}
      >
        <Footer />
      </div>
    </Container>
  );
};
const relatedTools = [
  {
    name: "SERP Simulator",
    icon: <FaSearch size={24} color="#0A3981" />,
    desc: "See how your site appears in Google results. A well-organized snippet can boost exposure, encourage more clicks, and enhance SEO performance in general.",
    href: "/serp-simulator",
  },
  {
    name: "Keyword Gap",
    icon: <FaChartBar size={24} color="#0A3981" />,
    desc: "Discover which keywords your competitors rank for that you don't. Uncover content opportunities, improve targeting, and close the gap in organic traffic efficiently.",
    href: "/keyword-gap",
  },
  {
    name: "Top Pages",
    icon: <FaFileAlt size={24} color="#0A3981" />,
    desc: "Identify your highest-performing pages by traffic and engagement. Use this insight to replicate success and refine your SEO content strategy effectively.",
    href: "/top-pages",
  },
];
const ToolSlider = () => {
  const sliderRef = useRef(null);

  const scrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollLeft -= 300;
    }
  };

  const scrollRight = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollLeft += 300;
    }
  };

  return (
    <div style={{ position: "relative" }}>
      {/* Left Arrow */}
      <button
        onClick={scrollLeft}
        style={{
          position: "absolute",
          left: "0",
          top: "-9%",
          transform: "translateY(-50%)",
          zIndex: 10,
          backgroundColor: "#799EFF",
          color: "#fff",
          border: "none",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          cursor: "pointer",
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        }}
      >
        <FaChevronLeft />
      </button>

      <button
        onClick={scrollRight}
        style={{
          position: "absolute",
          right: "0",
          top: "-9%",
          transform: "translateY(-50%)",
          zIndex: 10,
          backgroundColor: "#799EFF",
          color: "#fff",
          border: "none",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          cursor: "pointer",
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        }}
      >
        <FaChevronRight />
      </button>

      <div
        ref={sliderRef}
        className="mb-4"
        style={{
          display: "flex",
          overflowX: "auto",
          padding: "1rem",
          gap: "1rem",
          scrollbarWidth: "none",
          scrollBehavior: "smooth",
        }}
      >
        {relatedTools.map((tool, idx) => (
          <div
            key={idx}
            style={{
              minWidth: "250px",
              flex: "0 0 auto",
              background: "#f4f8ff",
              borderRadius: "12px",
              padding: "1rem",
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              textAlign: "center",
              transition: "transform 0.3s",
            }}
          >
            <div style={{ marginBottom: "0.5rem" }}>{tool.icon}</div>
            <h6 style={{ color: "#0A3981", fontWeight: "bold" }}>
              {tool.name}
            </h6>
            <p
              style={{
                fontSize: "0.9rem",
                minHeight: "60px",
                lineHeight: "1.4",
              }}
            >
              {tool.desc
                .split(" ")
                .map((word, i) =>
                  (i + 1) % 7 === 0 ? word + "\n" : word + " "
                )
                .join("")
                .split("\n")
                .map((line, idx) => (
                  <span key={idx}>
                    {line.trim()}
                    <br />
                  </span>
                ))}
            </p>
            <a
              href={tool.href}
              style={{
                color: "#fff",
                backgroundColor: "#799EFF",
                padding: "6px 12px",
                borderRadius: "8px",
                textDecoration: "none",
                display: "inline-block",
                fontWeight: "bold",
              }}
            >
              Try Now →
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};
const Content = () => {
  const [showMore, setShowMore] = useState(false);

  return (
    <div className="">
      <h2>What are the Linking Domains SEO?</h2>

      <p>
        Any special site that mentions yours is termed linking domain (or
        referring domain). Let’s say you get 500 backlinks. Suppose that they
        are (all) 5 websites, one will have 5 linking domains. But, 500
        different websites (backlinks) have 500 different linking domains.
      </p>

      <div style={{ position: "relative" }}>
        <p>
          Google does not just want back links. It wants back links that are
          given by several authoritative sources. That’s what helps you rank.
        </p>
        {!showMore && (
          <div
            style={{
              position: "absolute",
              bottom: "0.5rem",
              left: 0,
              right: 0,
              height: "2.5em",
              background:
                "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.8) 100%)",
            }}
          />
        )}
      </div>
      <div className="d-flex justify-content-center">
        {!showMore && (
          <Button
            onClick={() => setShowMore(true)}
            style={{
              padding: "6px 20px",
              backgroundColor: "#fff",
              color: "#0d6efd",
              fontWeight: "600",
              fontSize: "0.95rem",
              border: "2px solid #0d6efd",
              borderRadius: "999px",
              boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#0d6efd";
              e.target.style.color = "#fff";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#fff";
              e.target.style.color = "#0d6efd";
            }}
          >
            Read More
          </Button>
        )}
      </div>

      {showMore && (
        <>
          <div className="d-flex justify-content-center">
            <img
              className="mb-3"
              src={linking2}
              alt="seobix"
              style={{ width: "50vw" }}
            />
          </div>

          <h3>Why Referring Domains Matter More Than Backlinks</h3>

          <p>
            Imagine that somebody simply continues praising your work. Supposing
            then there were 100 persons who once praised you. Which makes more
            sense? More trustworthy? It is the same with search engines. When
            you have a large number of different domains as your backlinks, then
            it shows reach. It will prove that your content is being watched and
            distributed online. And that augers well for better rankings.
          </p>
          <p>
            That is why a referring domain checker is included in any serious
            audit of the SEO.
          </p>
          <div className="d-flex justify-content-center">
            <img
              className="mb-3"
              src={linking1}
              alt="seobix"
              style={{ width: "50vw" }}
            />
          </div>
          <h3>How To Test Linking Domains of a Webpage</h3>

          <p>
            You don’t need to be technical. Just use SeoBix. You put in the site
            URL, click the search and leave it to the system. Within a couple of
            seconds you receive a report that states:
          </p>
          <h4>What are your number of linking domains?</h4>
          <ul>
            <li>What sites are connecting with you?</li>
            <li>The quality of those sites (DA, PA, and Spam Score)</li>
            <li>What You Can Gain through Analysis of Link Building</li>
          </ul>

          <h3>What You Can Learn from Link Building Analysis</h3>
          <p>
            There are a few things that become obvious once you view the report.
          </p>
          <p>
            Probably, the majority of your links belong to low-authority sites.
            Or perhaps your two-year old blog post continues to drive high
            quality domains. In some cases you will find weird domains that will
            refer to you. That could be spam. And yeah, that matters too.
          </p>
          <p>
            The analysis of link building is not about the analysis of who is
            linking. It’s about spotting patterns. Knowing what’s working.
            What’s hurting? And what needs to be fixed?
          </p>
          <p>
            That type of information is gold in the planning of your strategies.
          </p>

          <h3>
            Reason why you should not base on the number of backlinks alone
          </h3>
          <p>
            The number of backlinks is impressive. But it’s easy to fake. With
            the right place to go, you can create 5,000 backlinks in one week.
            Yet are they all belong to the same 3 domains? Not helpful.
          </p>
          <p>
            That is why the specialists in SEO never stop on the diversity of
            domains. When the amount of reference domains is high, then you are
            normally doing something good. Having a low number despite having
            tonnes of backlinks may be an indication that your link strategy
            requires some effort.
          </p>
          <p>It’s not about quantity. It’s about variety.</p>

          <h3>Most Effective Tool to locate Linking Domains</h3>
          <p>
            There are tools out there. Tons of them. Some cost too much. Some
            are too complicated. And some are simply congested with information
            that no one knows.
          </p>
          <p>
            SeoBix keeps it easy. You search your site. It shows you linking
            domains. It makes you know how strong they are. And when they can be
            harmful it marks them. You do not require a deep understanding of
            SEO to use it.
          </p>

          <h3>What is the reason it needs a referencing domains checker?</h3>
          <p>Honestly? Anyone who owns a website.</p>
          <p>
            This can help you in case you are a blogger and are interested in
            boosting traffic.
          </p>
          <p>
            It plays a vital role whereby you have a business web page and you
            want to know who has been following you and when you are in the
            news.
          </p>
          <p>
            Freelancers, content creators, agencies, everybody likes to know who
            is sending them links. All the backlinks of a new domain are all
            trust signals and trust means traffic.
          </p>

          <h3>Repeat Errors to be Wary of</h3>
          <p>Lots of people mess this up.</p>
          <p>
            They put in consideration the quantity of the backlinks and not the
            variety of domains.
          </p>
          <p>
            Some of them buy the links in spammy areas, hoping that the links
            will earn them a boost.
          </p>
          <p>
            Their link profile is never visited at all by other people until the
            traffic is reduced and the ranking becomes poor.
          </p>
          <p>
            Don’t do that. Check with a referring domain checker. Keep the
            off-page SEO in check.
          </p>

          <h3>FAQs</h3>
          <p>
            <strong>
              What is the meaning of linking domains when it comes to SEO?
            </strong>
            <br />
            They are the only points related to your Web site. No matter the
            amount of backlinks which are created using a single domain; this is
            regarded as one linking domain.
          </p>
          <p>
            <strong>
              What is the major difference between backlinks and referring
              domains?
            </strong>
            <br />
            The cumulative number of links are referred to as backlinks.
            Referring domains are the number of different sites which the links
            are pointing to.
          </p>
          <p>
            <strong>
              What are the ways through which I can crosslink domains to my
              site?
            </strong>
            <br />
            Use a tool like SeoBix. Learn who is linking to you, the number of
            links and the strength of the links by entering your URL.
          </p>
          <p>
            <strong>
              What is so significant about the referring domains compared to the
              amount of backlinks?
            </strong>
            <br />
            Search engines are believers in diversification. One thousand links
            of a site do not make much sense. Half a million connection points,
            half a million different sites? That’s real authority.
          </p>
          <p>
            <strong>And can one have too many links of the same domain?</strong>
            <br />
            Yes. It can look unnatural. Google prefers the presence of a healthy
            and natural backlink profile that consists of links from different
            sites.
          </p>

          <h3>Final Thoughts</h3>
          <p>
            By leaving the linking domain out when doing your SEO, you are
            missing one of the biggest signals that search engines are worried
            about. Backlinks are good. But where do they come from? That is what
            matters.
          </p>
          <p>
            A connection domain checker like the one offered at SeoBix will help
            you to filter out the noise. It shows what’s real. What’s working?
            And what have you to correct?
          </p>
          <p>
            It is not a number chasing case. The thing is the issue of building
            trust, one sphere at a time. Then check your referring domains. Find
            out who’s linking to you. And start to do smarter things with it.
          </p>
          <p>
            Maybe, the majority of your links have low-authority. Or perhaps
            your two year old blog entry is still earning good grounds. There
            will be strange domains, which will be referring to you. That could
            be spam. And yeah, that matters too.
          </p>
          <p>
            The link building analysis is not the analysis of who has a link.
            It’s about spotting patterns. Knowing what’s working. What’s
            hurting? And what needs to be fixed?
          </p>
          <p>
            This kind of information is gold as far as strategizing is
            concerned.
          </p>
          <p>So, Check Your Linking Domain with SEOBIX</p>

          <div className="d-flex justify-content-center mt-4">
            <Button
              onClick={() => setShowMore(false)}
              style={{
                padding: "6px 20px",
                backgroundColor: "#fff",
                color: "#dc3545",
                fontWeight: "600",
                fontSize: "0.95rem",
                border: "2px solid #dc3545",
                borderRadius: "999px",
                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#dc3545";
                e.target.style.color = "#fff";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#fff";
                e.target.style.color = "#dc3545";
              }}
            >
              Hide
            </Button>
          </div>
        </>
      )}
      <Plancard />
      <Trialcards />
      <Related />
      <TestimonialPage />
      <Specialoffer />
      <BackLinkCards />
      <Plancard />
    </div>
  );
};
const Plancard = () => {
  const [isYearly, setIsYearly] = useState(false);
  const plans = [
    {
      title: "Free",
      monthly: "$0",
      yearly: "$0",
      Free: "3 Month Free Trial",
      features: ["Limited Access"],
      buttonText: "Buy Plan",
      color: "#e0f2fe",
      border: "#38bdf8",
      image: pay,
    },
    {
      title: "Basic",
      monthly: "$150/mo",
      features: ["5 Projects", "Standard Reports", "Email Support"],
      buttonText: "Buy Plan",
      color: "#e7f5ff",
      border: "#339af0",
      image: pay,
    },
    {
      title: "Standard",
      monthly: "$350/mo",
      features: ["10 Projects", "Advanced Reports", "Priority Support"],
      buttonText: "Buy Plan",
      color: "#e6fcf5",
      border: "#20c997",
      image: pay,
    },
    {
      title: "Premium",
      monthly: "$750/mo",
      features: ["Unlimited Projects", "All Features", "24/7 Support"],
      buttonText: "Buy Plan",
      color: "#fff3bf",
      border: "#fcc419",
      image: pay,
    },
  ];

  return (
    <Container className="my-5">
      <div className="text-center mb-4">
        <h2 style={{ fontWeight: "700", fontSize: "2rem" }}>
          Boost Your SEO With Our Amazing Plans
        </h2>
        <h4 className="font-weight-bold mb-4" style={{ color: "#441752" }}>
          🚀 Improve Your Rankings —{" "}
          <span style={{ color: "#FC4100" }}>
            Try Our Service Free for 3 Months!
          </span>
        </h4>
        <p style={{ color: "#6b7280" }}>
          Flexible pricing plans designed for every stage of your journey
        </p>
        <div className="d-flex justify-content-center mt-4">
          <div className="d-flex align-items-center gap-2">
            <span style={{ fontWeight: "500" }}>Monthly</span>

            <div
              className="m-2"
              style={{ transform: "scale(1.5)", transformOrigin: "center" }}
            >
              <Form.Check
                type="switch"
                id="custom-switch"
                checked={isYearly}
                onChange={() => setIsYearly(!isYearly)}
              />
            </div>

            <div className="d-flex align-items-center gap-2">
              <span style={{ fontWeight: "500" }}>Yearly</span>

              <div
                className="start-now-btn mx-3"
                style={{
                  backgroundColor: "#e6f4ea",
                  color: "#2f855a",
                  padding: "6px 12px",
                  borderRadius: "8px solid",
                  fontWeight: "600",
                  fontSize: "0.9rem",
                  border: "1px solid #20c997",
                }}
              >
                🎉{" "}
                <span style={{ color: "#0B1D51" }}>
                  Get{" "}
                  <span style={{ color: "#0B1D51" }}>
                    <b>30% OFF</b>
                  </span>{" "}
                  on Yearly Plans
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Row className="g-4 justify-content-center">
        {plans.map((plan, idx) => (
          <Col md={6} lg={3} key={idx}>
            <div style={{ position: "relative" }}>
              {plan.title === "Free" && (
                <div
                  style={{
                    position: "absolute",
                    top: "-12px",
                    left: 0,
                    right: 0,
                    height: "32px",
                    backgroundColor: "#38bdf8",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    borderTopLeftRadius: "16px",
                    borderTopRightRadius: "16px",
                    zIndex: 2,
                  }}
                >
                  {plan.Free}
                </div>
              )}

              <Card
                className="p-2"
                style={{
                  backgroundColor: plan.color,
                  border: `2px solid ${plan.border}`,
                  borderRadius: "16px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow:
                    plan.title === "Free"
                      ? "0 12px 28px rgba(56, 189, 248, 0.5)"
                      : "0 4px 12px rgba(0,0,0,0.05)",
                  marginTop: plan.title === "Free" ? "16px" : "0",
                }}
              >
                <Card.Body>
                  <Card.Title style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                    {plan.title}
                  </Card.Title>
                  <h3 style={{ fontWeight: "bold", margin: "1rem 0" }}>
                    {isYearly
                      ? plan.title === "Free"
                        ? plan.yearly
                        : (() => {
                            const monthlyPrice = parseFloat(
                              plan.monthly.replace(/[^0-9.]/g, "")
                            );
                            const yearlyRaw = monthlyPrice * 12;
                            const discounted = yearlyRaw * 0.7;
                            return `$${Math.round(discounted)}/yr`;
                          })()
                      : plan.monthly}
                  </h3>
                  <a
                    href="/register"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-block",
                      backgroundColor: plan.border,
                      color: "white",
                      textDecoration: "none",
                      borderRadius: "999px",
                      padding: "8px 20px",
                      fontWeight: "600",
                      marginTop: "1rem",
                    }}
                  >
                    {plan.buttonText}
                  </a>

                  <div className="mt-3">
                    <img
                      src={plan.image}
                      alt={plan.title}
                      style={{
                        // width: "15vw",
                        objectFit: "contain",
                        marginBottom: "1rem",
                      }}
                    />
                  </div>
                </Card.Body>
              </Card>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};
const Trialcards = () => {
  const cardsData = [
    {
      keyImg: key1,
      coreImg: core5,
      title: "Integrated Search Console, Google Trends and Google Analytics",
      desc: "Smarter SEO insights in one place and see what’s popular in different countries and other website matrics. Seobix makes it easy and effective.",
    },
    {
      keyImg: key2,
      coreImg: core4,
      title: "Search Engine Optimization",
      desc: "SEO gets easier with SeoBix whether you just start your website or growing your online presence. Our all-in-one SEO tool helps you fix issues and improve online visibility.",
    },
    {
      keyImg: key3,
      coreImg: core2,
      title: "Social Media Optimization",
      desc: "You can monitor and post from all your favorite platforms, YouTube, Facebook, LinkedIn, and Instagram, all from under one roof.",
    },
    {
      keyImg: key4,
      coreImg: core1,
      title: "Competitive Research Overview",
      desc: "You can check domain overview and website age and how their pages look on Google with our SERP Simulator. Seobix gives you the insights you need to compete smarter, not harder.",
    },
    {
      keyImg: key5,
      coreImg: core3,
      title: "Structure Data",
      desc: "With the right setup, At Seobix, we make it super easy to add and check structured data, so your site gets noticed for all the right reasons.",
    },
    {
      keyImg: key6,
      coreImg: core6,
      title: "Keyword Research",
      desc: "Our Bix keyword Research helps you discover high-potential keywords your audience is actually searching for.",
    },
  ];
  return (
    <div className="mt-md-5 mt-3 m-md-0 m-2 ">
      <h2
        className="text-center m-4"
        style={{ fontWeight: "700", fontSize: "2rem" }}
      >
        What Includes In All Plans ?
      </h2>
      <div className="row m-0 p-0">
        {cardsData.map((card, index) => (
          <div key={index} className="col-12 col-md-4 p-2 d-flex">
            <div className="card w-100 h-100 p-2">
              <div className="d-flex h-100">
                <div
                  style={{ flex: 1 }}
                  className="d-flex flex-column position-relative"
                >
                  <div>
                    <img
                      src={card.keyImg}
                      alt={card.title}
                      style={{
                        height: "5vh",
                        objectFit: "contain",
                        marginBottom: "0.5rem",
                      }}
                    />
                    <h5>{card.title}</h5>
                  </div>
                </div>

                <div
                  style={{ flex: 1 }}
                  className="d-flex align-items-center justify-content-center"
                >
                  <img
                    src={card.coreImg}
                    alt={card.title}
                    className="img-fluid"
                    style={{ maxHeight: "200px", objectFit: "contain" }}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
const Specialoffer = () => {
  return (
    <div
      className="start-now-btn p-2"
      style={{
        background: "#799EFF",
        borderRadius: "24px",
        color: "white",
        textAlign: "center",
        margin: "3rem auto",
        width: "90%",
        maxWidth: "1000px",
        position: "relative",
      }}
    >
      <h2 className="mb-3" style={{ fontSize: "2rem", fontWeight: "bold" }}>
        Let’s do this! Start unlocking powerful backlink insights.
      </h2>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "16px",
          flexWrap: "wrap",
        }}
      >
        <a
          // href="/register"
          onClick={() => window.open("https://dashboard.seobix.com/", "_blank")}
          style={{
            backgroundColor: "#fff",
            color: "#000",
            padding: "12px 24px",
            borderRadius: "12px",
            fontWeight: "600",
            textDecoration: "none",
            minWidth: "150px",
            textAlign: "center",
          }}
        >
          Start 3 Months Free Trial
        </a>
      </div>

      <p style={{ color: "#fff", marginTop: "20px", fontSize: "14px" }}>
        <b> Full access — No Credit card Needed.</b>
      </p>
    </div>
  );
};
const Related = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [selfDomain, setSelfDomain] = useState("");
  const [competitorDomain, setCompetitorDomain] = useState("");
  const [selectedDomainType, setSelectedDomainType] = useState({
    value: "root",
    label: "Root Domain",
  });
  const [expandedRow, setExpandedRow] = useState(null);
  const [apiData, setApiData] = useState([]);
  const handleRowExpand = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  };
  const generateUUID = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };
  const { password, username } = basicauth;
  const base64Credentials = btoa(`${username}:${password}`);
  const handleSubmit = async () => {
    const uuid = generateUUID();
    const session = generateUUID();
    const urls = [selfDomain, competitorDomain].filter(Boolean);
    setLoading(true);
    const scope = selectedDomainType.value === "root" ? "domain" : "subdomain";
    const requestData = {
      uuid,
      urls,
      scope,
      session,
    };
    console.log("Request Data:", requestData);
    try {
      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/CompetitiveResearch/FetchBulkSiteMetrics`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        }
      );

      const data = await response.json();
      if (data.status === "0") {
        setApiData(data.data);
        setLoading(false);
      } else {
        console.error("Error fetching data:", data.msg);
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setLoading(false);
    }
  };

  const handleClick = () => {
    navigate("/keyword-gap");
  };

  return (
    <div className="mt-5 mb-5">
      <div
        // onClick={handleClick}
        style={{
          cursor: "pointer",
        }}
      >
        <Row
          className="justify-content-center"
          style={{
            margin: "0",
            background:
              "linear-gradient(to right, #AFDDFF 0%, #C5E7FF 30%, #DAF0FF 60%, #EDF8FF 85%, #FFFFFF 100%)",
            borderRadius: "12px",
            transition: "transform 0.2s ease",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "scale(1.01)")
          }
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          <Col md={10} className="p-3">
            <h3 className="text-center">
              <b>Find Keyword Gaps vs Your Competitors</b>
            </h3>
            <p className="text-center">
              Discover which keywords your competitors rank for — but you don’t.
              Uncover missed SEO opportunities and boost your content strategy.
            </p>

            <Form className="mb-2">
              <Row className="align-items-center gx-2">
                <Col md={4}>
                  <Form.Group className="mb-0">
                    <Form.Control
                      type="text"
                      placeholder="Enter your domain"
                      value={selfDomain}
                      onChange={(e) => setSelfDomain(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-0">
                    <Form.Control
                      type="text"
                      placeholder="Enter competitor domain"
                      value={competitorDomain}
                      onChange={(e) => setCompetitorDomain(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Row className="g-2 align-items-center">
                    <Col xs={9}>
                      <Form.Group className="mb-0">
                        <Form.Select
                          value={selectedDomainType}
                          onChange={(e) =>
                            setSelectedDomainType(e.target.value)
                          }
                          aria-label="Select Domain Type"
                          style={{
                            borderRadius: "6px",
                            padding: "0.5rem",
                            fontWeight: "500",
                            color: "#333",
                            backgroundColor: "#fff",
                            border: "1px solid #ccc",
                          }}
                        >
                          <option value="">Select Domain Type</option>
                          <option value="root">Root Domain</option>
                          <option value="sub">Sub Domain</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col xs={3}>
                      <Button
                        size="sm"
                        variant="primary"
                        onClick={handleSubmit}
                        style={{ whiteSpace: "nowrap", width: "100%" }}
                      >
                        Submit
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
            <div className=" mt-4">
              {apiData.length > 0 && (
                <Table responsive>
                  <colgroup>
                    <col style={{ width: "25%" }} />
                    <col style={{ width: "20%" }} />
                    <col style={{ width: "20%" }} />
                    <col style={{ width: "20%" }} />
                  </colgroup>

                  <thead>
                    <tr>
                      <th className="text-center">Domain</th>
                      <th className="px-3">Domain Authority</th>
                      <th className="px-3">Page Authority</th>
                      <th className="px-3">Spam Score</th>
                    </tr>
                  </thead>
                  <tbody>
                    {apiData.map((item, index) => (
                      <React.Fragment key={item.id}>
                        <tr>
                          <td className="text-center">{item.url}</td>

                          <td
                            className="p-2"
                            style={{ width: "100px", textAlign: "center" }}
                          >
                            <CustomDoughnut
                              value={item.da}
                              stroke="#799EFF"
                              label={`${item.da}`}
                            />
                          </td>

                          <td
                            className="p-2"
                            style={{ width: "100px", textAlign: "center" }}
                          >
                            <CustomDoughnut
                              value={item.pa}
                              stroke="#FFA500"
                              label={`${item.pa}`}
                            />
                          </td>

                          <td
                            className="p-2"
                            style={{ width: "100px", textAlign: "center" }}
                          >
                            <CustomDoughnut value={item.spam_score} />
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                  </tbody>
                </Table>
              )}
            </div>
            <h6 className="text-end m-4" onClick={handleClick}>
              Click to get more details <FaArrowRight />
            </h6>
          </Col>
        </Row>
      </div>
    </div>
  );
};
const CustomDoughnut = ({ value, size = 64 }) => {
  const strokeWidth = 10;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const progress = ((100 - value) / 100) * circumference;

  return (
    <div
      style={{
        width: `${size}px`,
        height: `${size}px`,
        position: "relative",
      }}
    >
      <svg width={size} height={size}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="#e0e0e0"
          strokeWidth={strokeWidth}
          fill="none"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="#799EFF"
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={progress}
          strokeLinecap="round"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          fontSize: "14px",
          fontWeight: "bold",
          color: "#0A3981",
        }}
      >
        {value}%
      </div>
    </div>
  );
};
const cardData = [
  {
    title: "Backlink Checker",
    description:
      "Easy Find out which links are missing or harmful on your site and which are not.",
    linkText: "Backlink Checker",
    linkUrl: "/backlink-checker",
    bgColor: "#f4f7fb",
  },
  {
    title: "Top Pages",
    description:
      "Compare and analyze the performance of your most linked pages and that of your competitors. Learn about high-impact SEO opportunities.",
    linkText: "Top Pages",
    linkUrl: "/top-pages",
    bgColor: "#dff5ff",
  },
  {
    title: "Link Building Tool",
    description:
      "Determine broken or lost backlinks and turn them into new opportunities to establish stronger relations.",
    linkText: "Link Building Tool",
    linkUrl: "/link-building-tool",
    bgColor: "#f4f7fb",
  },
  {
    title: "Domain Authority",
    description:
      "Assess the authority rating and any future search engine of a web site with more than 15 reliable ranking factors and domain measures.",
    linkText: "DA Checker",
    linkUrl: "/da-pa-checker",
    bgColor: "#d6ffd6",
  },
];
const BackLinkCards = () => {
  return (
    <div style={{ overflow: "hidden", padding: "20px" }}>
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold">
            Backlink Optimization Toolkit: Everything You Need
          </h2>
        </div>
        <div className="row justify-content-center g-4">
          {cardData.map((card, index) => (
            <div key={index} className="col-md-6 col-lg-3 p-1">
              <div
                style={{
                  backgroundColor: card.bgColor,
                  padding: "24px",
                  borderRadius: "20px",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <h5 className="fw-bold">{card.title}</h5>
                  <p className="text-muted" style={{ fontSize: "15px" }}>
                    {card.description}
                  </p>
                </div>
                <div>
                  <a
                    href={card.linkUrl}
                    className="text-primary fw-semibold"
                    style={{ textDecoration: "none" }}
                  >
                    {card.linkText} →
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default Linkingdomain;
